import GlobalImageComponent from "@/components/Comman/GlobalImageComponent";

const paymentData = [
  {
    bg: "https://www.baghaffiliates.xyz/payments/bkash1.png",
    src: "https://www.baghaffiliates.xyz/_next/image?url=%2Fpayments%2Fbkash2.png&w=48&q=75",
  },
  {
    bg: "https://www.baghaffiliates.xyz/payments/rocket1.png",
    src: "https://www.baghaffiliates.xyz/_next/image?url=%2Fpayments%2Frocket2.png&w=48&q=75",
  },
  {
    bg: "https://www.baghaffiliates.xyz/payments/nagad1.png",
    src: "https://www.baghaffiliates.xyz/_next/image?url=%2Fpayments%2Fnagad2.png&w=48&q=75",
  },
  {
    bg: "https://www.baghaffiliates.xyz/payments/upay1.png",
    src: "https://www.baghaffiliates.xyz/_next/image?url=%2Fpayments%2Fupay2.png&w=48&q=75",
  },
  {
    bg: "https://www.baghaffiliates.xyz/payments/usdt1.png",
    src: "https://www.baghaffiliates.xyz/_next/image?url=%2Fpayments%2Fusdt2.png&w=48&q=75",
  },
];

const licenseIcons = [
  "https://www.baghaffiliates.xyz/_next/image?url=%2Flicenses%2F18%2B.png&w=64&q=75",
  "https://www.baghaffiliates.xyz/_next/image?url=%2Flicenses%2Fgamcare.png&w=64&q=75",
  "https://www.baghaffiliates.xyz/_next/image?url=%2Flicenses%2Fbga.png&w=64&q=75",
  "https://www.baghaffiliates.xyz/_next/image?url=%2Flicenses%2Fdmca.png&w=64&q=75",
];

const FooterPaymentSection = () => {
  return (
    <div className="mt-8.5 flex justify-between lg:flex-row flex-col gap-15">
      <div className="max-w-58.5 w-full">
        <h3 className="text-xl font-bold text-white">Payment Methods</h3>

        <div className="mt-6 flex items-center gap-2">
          {paymentData.map((item, i) => (
            <figure
              key={i}
              className="size-10 rounded-full bg-contain group"
              style={{ backgroundImage: `url(${item.bg})` }}
            >
              <GlobalImageComponent
                src={item.src}
                alt="payment icon"
                width={40}
                height={40}
                className="opacity-0 group-hover:opacity-100 transition-all"
                objectFit="contain"
              />
            </figure>
          ))}
        </div>
      </div>

      <div className="max-w-81.5 w-full">
        <h3 className="text-xl font-bold text-white">Responsible Gaming</h3>

        <div className="mt-6 flex items-center gap-2.5">
          {licenseIcons.map((item, i) => (
            <GlobalImageComponent
              key={i}
              src={item}
              width={60}
              height={45}
              alt="license icon"
              className="object-contain h-11 aspect-video"
              objectFit="contain"
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FooterPaymentSection;
